import PropTypes from 'prop-types'
import React from 'react'

import { ContactDetailsSection } from './ContactDetailsSection'
import DealerSwitcher from './DealerSwitcher'

// A secondary header under the nav bar: full width, flush to the top of the page, in
// Mark's second-tier navy (#031053, `blue-950`). The negative margins cancel AppShell's
// padding and the inner padding puts it back, so the text still lines up with the page.
const BAND =
  '-mx-4 -mt-6 mb-4 bg-blue-950 px-4 py-2.5 text-white sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8'
const BAND_ROW = 'flex min-h-[2rem] flex-wrap items-center justify-between gap-x-6 gap-y-1'

/**
 * The dealer's name (which is also the dealer switcher) and contact details, in a band
 * under the nav bar. The Outstanding List / RO Claims / Billing button group that used to
 * sit here is now the same three items in the nav bar itself.
 */
export const DealerHeader = ({ dealer, isROServiceUser }) => (
  <div className={BAND}>
    <div className={BAND_ROW}>
      {dealer?.name ? (
        // The dealer's name, which is also the dealer switcher.
        <DealerSwitcher dealer={dealer} />
      ) : (
        <div className="h-5 w-56 animate-pulse rounded-md bg-white/20" />
      )}

      <ContactDetailsSection dealer={dealer} isROServiceUser={isROServiceUser} loading={!dealer} />
    </div>
  </div>
)

DealerHeader.propTypes = {
  dealer: PropTypes.object,
  isROServiceUser: PropTypes.bool.isRequired,
}

/**
 * The same band with no dealer picked: "All dealers", which is also the switcher, and an
 * optional note on the right where a dealer's contact details would be (WARP-960).
 */
export const AllDealersHeader = ({ children }) => (
  <div className={BAND}>
    <div className={BAND_ROW}>
      <DealerSwitcher label="All dealers" />
      {children && <div className="text-sm text-white/70">{children}</div>}
    </div>
  </div>
)

AllDealersHeader.propTypes = {
  children: PropTypes.node,
}

AllDealersHeader.defaultProps = {
  children: null,
}
